export class DIState {
  number: number;
  value: number;

  constructor() {
    this.number = 0;
    this.value = 0;
  }
}

export interface DigitalInStatus {
  DI: DIState[];
}

